import { store } from "../../../redux/store";
import { billingApi } from "../../../redux/apis/billingApi";
import { clientConfigurationApi } from "../../../redux/apis/clientConfigurationApi";
import { buildInvoicePdfModel } from "./buildInvoicePdfModel";
import { openInvoicePdfPreview } from "./generateInvoicePdfPreview";

async function fetchQuery(endpoint, arg) {
  const result = await store.dispatch(endpoint.initiate(arg, { forceRefetch: true }));
  if (result.error) {
    throw result.error;
  }
  return result.data;
}

function resolveClientName(custgroup, draft) {
  const key = String(custgroup ?? "").trim().toLowerCase();
  if (!key) {
    return "";
  }
  return String(draft?.clientName ?? "").trim();
}

export async function previewSavedInvoicePdf(invoiceId) {
  const numericInvoiceId = Number(invoiceId);
  if (!Number.isFinite(numericInvoiceId) || numericInvoiceId <= 0) {
    throw new Error("Save the invoice draft before previewing the PDF.");
  }

  const draft = await fetchQuery(
    billingApi.endpoints.getDraftClientInvoiceById,
    numericInvoiceId
  );
  if (!draft) {
    throw new Error("Could not load the saved invoice draft.");
  }

  const custgroup = String(draft.custgroup ?? "").trim();
  const invoiceProgram = String(draft.invoiceProgramName ?? "").trim();
  const custId = Number(draft.custId);

  const [profileDetails, jobNos, customer, contracts, accountExecutives, clientOptionsPage] =
    await Promise.all([
      custgroup && invoiceProgram
        ? fetchQuery(clientConfigurationApi.endpoints.getClientConfigurationCustgroupInvProfileDetails, {
            custgroup,
            invoiceProgram,
          })
        : Promise.resolve([]),
      custgroup && invoiceProgram
        ? fetchQuery(clientConfigurationApi.endpoints.getClientConfigurationCustgroupInvProfileJobnos, {
            custgroup,
            invoiceProgram,
          })
        : Promise.resolve([]),
      Number.isFinite(custId) && custId > 0
        ? fetchQuery(clientConfigurationApi.endpoints.getClientConfigurationCustomer, custId)
        : Promise.resolve(null),
      Number.isFinite(custId) && custId > 0
        ? fetchQuery(clientConfigurationApi.endpoints.getClientConfigurationCustomerContracts, custId)
        : Promise.resolve([]),
      custgroup
        ? fetchQuery(
            clientConfigurationApi.endpoints.getClientConfigurationCustgroupAccountExecutives,
            custgroup
          )
        : Promise.resolve([]),
      custgroup
        ? fetchQuery(clientConfigurationApi.endpoints.getClientConfigurationCustgroupsDirectory, {
            page: 1,
            size: 100,
            search: custgroup,
            includeCounts: false,
          })
        : Promise.resolve(null),
    ]);

  const directoryMatch = (clientOptionsPage?.items ?? []).find(
    (row) => String(row.clientCode ?? "").trim().toLowerCase() === custgroup.toLowerCase()
  );
  const clientName =
    String(directoryMatch?.clientName ?? directoryMatch?.custName ?? "").trim() ||
    resolveClientName(custgroup, draft);

  const model = buildInvoicePdfModel({
    draft,
    customer,
    contracts,
    accountExecutives,
    profileDetails,
    jobNos,
    clientName,
  });

  await openInvoicePdfPreview(model);
}
